module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myPrivileges"
  }, [_c('div', {
    staticClass: "myPrivileges-out"
  }, [_c('p', {
    staticClass: "myPrivileges-tit"
  }, [_vm._v("我的特权")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-des"
  }, [_vm._v("加快求职速度，快人一步")]), _vm._v(" "), _c('div', {
    staticClass: "privileges-category"
  }, [_vm._l((_vm.privilegesCategorys), function(category, index) {
    return _c('span', {
      class: {
        'now-privilege': index === _vm.nowIndex
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goto(index)
        }
      }
    }, [_vm._v(_vm._s(category))])
  }), _vm._v(" "), (_vm.cardState === 20) ? _c('span', {
    class: {
      'now-privilege': _vm.nowIndex === 2
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goto(2)
      }
    }
  }, [_c('i', {
    staticClass: "icon-upgrade"
  }), _vm._v(" 专属客服")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "index-wrap"
  }, [_c('div', {
    staticClass: "slide-show",
    on: {
      "mouseover": _vm.clearInv
    }
  }, [_c('div', {
    staticClass: "slide-img"
  }, [_c('transition', {
    attrs: {
      "name": "slide-trans"
    }
  }, [(_vm.isShow) ? _c('div', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nowIndex === 0),
      expression: "nowIndex===0"
    }],
    key: "0",
    staticClass: "myPrivileges-in clearfix",
    class: {
      'upgrade-privileges': _vm.cardState === 20
    }
  }, [_c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show('ypyx')
      }
    }
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-ypyx-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("应聘优先")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("投递简历优先展示")]), _vm._v(" "), (_vm.vipState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("立即使用")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.topResume($event)
      }
    }
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-jlzd-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("简历置顶")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("可使用" + _vm._s(_vm.leftTop) + "天")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v(_vm._s(_vm.resumeListNum ? '立即置顶' : '创建简历'))])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show('tdtq')
      }
    }
  }, [_c('dl', [_c('dt', [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-tdtq-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("投递特权")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("可投递25次")]), _vm._v(" "), (_vm.vipState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("立即使用")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        return _vm.show('wxsx')
      }
    }
  }, [_c('dl', [_c('dt', [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-wxsx-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("免费刷新")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("任性刷刷刷")]), _vm._v(" "), (_vm.vipState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("立即使用")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), (_vm.cardState === 20) ? _c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-wxsx-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("直通服务")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("直接面试直通名企")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nowIndex === 1),
      expression: "nowIndex===1"
    }],
    key: "1",
    staticClass: "myPrivileges-in clearfix"
  }, [_c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show('qzbz')
      }
    }
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-qzbz-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("求职保障")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("无面试58包赔")]), _vm._v(" "), (_vm.vipState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("立即使用")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show('ccaq')
      }
    }
  }, [_c('dl', [_c('dt', [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-ccaq-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("财产安全险")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("为您的财产保驾护航")]), _vm._v(" "), (_vm.insuranceState === 2) ? _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn"
  }, [_vm._v("申请投保")])]) : _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])])]), _vm._v(" "), (_vm.cardState === 20) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nowIndex === 2),
      expression: "nowIndex===2"
    }],
    key: "2",
    staticClass: "myPrivileges-in clearfix"
  }, [_c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-zskf-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("专属客服")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("24小时解疑答惑")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card"
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-hjld-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("面试技巧")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("面试技巧相关培训")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-fpaq-small.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("防骗安全提醒")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("规避面试风险")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-zgbs-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("简历服务")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("提供优秀简历模板")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "myPrivileges-card "
  }, [_c('dl', [_c('dt', {
    staticClass: "myPrivileges-card-img"
  }, [_c('img', {
    staticClass: "myPrivileges-card-img",
    attrs: {
      "src": require("../../../../assets/imgs/priv-ypyx-big.png")
    }
  })]), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "myPrivileges-card-tit"
  }, [_vm._v("用户关怀")]), _vm._v(" "), _c('p', {
    staticClass: "myPrivileges-card-des"
  }, [_vm._v("贴心定制化服务")]), _vm._v(" "), _c('div', {
    staticClass: "myPrivileges-cardbtn-wrap"
  }, [_c('span', {
    staticClass: "myPrivileges-card-btn myPrivileges-card-btnNo"
  }, [_vm._v("正在使用")])])])])])]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _c('ul', {
    staticClass: "slide-pages myPrivileges-slide-bar"
  }, _vm._l((_vm.slides), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goto(index)
        }
      }
    }, [_c('span', {
      key: index,
      staticClass: "bar-com",
      class: {
        'bar-active': index === _vm.nowIndex
      }
    })])
  }), 0)])])]), _vm._v(" "), (_vm.showTop) ? _c('resume-top-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "topBtnChange": _vm.topBtnChange,
      "show-alert": _vm.showAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showLight) ? _c('gold-light-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "lightBtnChange": _vm.lightBtnChange,
      "show-alert": _vm.showAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZgbs) ? _c('zgbs-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWxsx) ? _c('wxsx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQzfx) ? _c('qzfx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGrrz) ? _c('grrz-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog,
      "authDialog": _vm.showAuthDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showJlzd) ? _c('jlzd-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog,
      "topResume": _vm.topResume
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHjld) ? _c('hjld-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog,
      "hightResume": _vm.hightResume
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTdtq) ? _c('tdtq-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQzbz) ? _c('qzbz-dialog', {
    attrs: {
      "vipState": _vm.vipVersionState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "compensateDialog": _vm.compensateDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCcaq) ? _c('ccaq-dialog', {
    attrs: {
      "vipState": _vm.vipVersionState,
      "insuranceState": _vm.insuranceState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "compensateDialog": _vm.compensateDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showYpyx) ? _c('ypyx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZskf) ? _c('zskf-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSuccess) ? _c('cvip-alert', {
    attrs: {
      "buttonTxt": "我知道了",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-success"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.alertTxt))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0953d2fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/myPrivileges/MyPrivileges.vue
// module id = Nqoy
// module chunks = 1